// extracted by mini-css-extract-plugin
export default {"tile":"daily-specialsPJq7dQ","tile--super-offer":"daily-specialslPZaQT","tile__anchor":"daily-specials2slbm6","tile__actions":"daily-specialso56TH-"};